import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { pashuposhanInterceptor } from './interceptor/pashuposhan.interceptor';
import { environment } from '../environments/environment';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';

export const appConfig: ApplicationConfig = {
  // providers: [provideRouter(routes), provideClientHydration()]

  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withInterceptors([pashuposhanInterceptor])),
    provideAnimations(),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey // Use site key from environment
    }
  ]
};
